<template>
  <v-container class="processos-legislativo">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        icon="mdi-pencil-box-outline"
        main="Atividades Legislativas"
        sub="Projetos de Lei"
        home='/Legislativo'
      />
      <div>
        <formulario />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Formulario from '../processos/index.vue'
// import Stat from './Stat'
// import axios from 'axios'
// import { baseApiUrl } from '../../global'
export default {
  name: 'ProcessosLegislativo',
  components: { PageTitle, Formulario },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
